import { Grid } from '@material-ui/core';
import { Backdrop, Checkbox, Select, Switch, TextInput } from '@room-match/shared-ui-components';
import { useEffect, useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { IAccountDeleteRequestPayload } from 'shared/interfaces/IAccount';
import { userLogout } from 'shared/redux/slicers/user.slicer';
import { accountService } from 'shared/services/accountService';
import { getErrorMessage } from 'shared/utils/room-shared';

import { CheckboxContainer, Content, CustomButton, CustomText, useStyles } from './ManageAccount.styles';
import { useAccountDeletionForm } from './ManageAccountForm';
import { talentService } from 'shared/services/talentService';
import { useAppSelector } from 'shared/redux/store';
import { useDebounce } from 'use-debounce';

const reasonList = [
  {
    key: 'I am leaving the industry',
    value: 'I am leaving the industry',
  },
  {
    key: "I don't wish to use this service anymore",
    value: "I don't wish to use this service anymore",
  },
  {
    key: 'I am retiring',
    value: 'I am retiring',
  },
  {
    key: 'I am concerned how my data is being used',
    value: 'I am concerned how my data is being used',
  },
  {
    key: 'Other',
    value: 'Other',
  },
];

const { deleteAccount } = accountService();
const { updateMe } = talentService();
const ManageAccount = () => {
  const { user: userState } = useAppSelector((state: any) => state);
  const { mutate: updateMeMutation } = updateMe();
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const { mutateAsync, isLoading } = deleteAccount();
  const [enableSMS, setenableSMS] = useState<boolean | null>(null);
  const [smsVal] = useDebounce(enableSMS, 500);
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const handleSubmit = (values: IAccountDeleteRequestPayload) => {
    mutateAsync(values, {
      onSuccess: () => {
        queryClient.invalidateQueries(['accounts'], {
          refetchInactive: true,
        });
        dispatch(userLogout());
      },
    });
  };

  const { form } = useAccountDeletionForm({
    onSubmit: handleSubmit,
  });
  const preferences = useMemo(() => {
    return userState?.user?.attributes.preferences;
  }, [userState]);

  const handleToggleSMS = () => {
    //check if preferences has notification then spread it, else create a new object
    let notification = preferences?.notification ? { ...preferences.notification } : {};
    updateMeMutation(
      {
        preferences: { ...preferences, notification: { ...notification, sms: smsVal } },
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries(['me']);
        },
      },
    );
  };

  useEffect(() => {
    if (!preferences || smsVal === null || smsVal === preferences?.notification?.sms) return;

    handleToggleSMS();
  }, [smsVal]);

  useEffect(() => {
    if (preferences?.notification) setenableSMS(preferences?.notification?.sms);
  }, [preferences]);

  return (
    <>
      <CustomText size={25}>Text/SMS Notifications</CustomText>
      <div className={classes.main}>
        <Switch
          disableMargin
          checked={Boolean(enableSMS)}
          toggle={() => {
            setenableSMS((prev) => !prev);
          }}
          style={{
            marginLeft: '-20px !important',
            //css for switchContent
          }}
          disabled={false}
        />
        <CustomText
          size={16}
          style={{
            marginLeft: '10px',
          }}
        >
          I Opt to receive Text/SMS notifications to my registered Mobile/Cell number, regarding my Audition, Self-Tape
          and Booking requests via the platform directly or my Representatives. As well as Account, Project and
          important system notifications.
        </CustomText>
      </div>
      <CustomText size={25}>Request Account Deletion</CustomText>
      <Content>
        <Grid item lg={3} md={4} xs={12}>
          <Select
            variant="outlined"
            data={reasonList}
            // IconComponent={SelectArrowDownIcon}
            fullWidth
            className={classes.select}
            placeHolder="Select a Reason"
            name="reason"
            value={form.values.reason}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            errorMessage={getErrorMessage(form.touched.reason, form.errors.reason)}
          />
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <TextInput
            label={'Message'}
            placeholder="Enter your message here…"
            textArea={true}
            textAreaMinRows={8}
            name="message"
            value={form.values.message}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
          />
        </Grid>
        <Grid item lg={12} md={12} xs={12}>
          <CheckboxContainer item lg={12} md={12} xs={12}>
            <Checkbox
              label="I agree that if I do this, I will lose all of my data related to projects I have been a part of and there is no going back."
              name="default"
              labelPlacement="end"
              value={isChecked}
              onChange={() => setIsChecked(!isChecked)}
            />
          </CheckboxContainer>
        </Grid>
        <Grid item lg={3} md={4} xs={12}>
          <CustomButton
            variant="contained"
            color="primary"
            fullWidth
            disabled={!isChecked}
            onClick={() => form.handleSubmit()}
          >
            Submit
          </CustomButton>
        </Grid>
        <Backdrop isLoading={isLoading} />
      </Content>
    </>
  );
};

export default ManageAccount;
